import { useContext } from 'react'

import { Box, Divider, Paper, Snackbar, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import PremiumInsightsInsightsContext from '../PremiumInsightsProvider/Context'
import InsightsEngagement from './InsightsEngagement'
import InsightsFilters from './InsightsFilters'
import InsightsReach from './InsightsReach'
import Loading from './Loading'

export default function Insights() {
  const { getCollegePremiumInsightsRequest } = useContext(PremiumInsightsInsightsContext)
  const loading = getCollegePremiumInsightsRequest.status === 'loading'

  return (
    <Paper elevation={0}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gridGap={8}
        p={2}
      >
        <Typography
          variant="h6"
          component="h2"
        >
          Insights
        </Typography>
        <InsightsFilters />
      </Box>
      <Divider light />
      {loading ? (
        <Loading />
      ) : (
        <Box p={2}>
          <Box>
            <InsightsReach />
          </Box>
          <Box mt={3}>
            <InsightsEngagement />
          </Box>
        </Box>
      )}
      <Snackbar
        open={getCollegePremiumInsightsRequest.status === 'error'}
        autoHideDuration={6000}
      >
        <Alert severity="error">There was an error loading metrics</Alert>
      </Snackbar>
    </Paper>
  )
}
